module.exports = __webpack_public_path__ + "b06645d217f95d707c09431bb83feb72.png";